import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Grommet } from 'grommet';
import { useTitle } from 'react-use';

// pages
import {
  MapPage,
  DetailPage,
  SearchPage,
  withAppLayout,
  NotFoundPage,
  AdminComponent,
  AdminLogoutComponent,
  AdminSignedInComponent,
  AdminSignedOutComponent,
  MdiPage,
  TagListPage,
} from './pages';

// grommet custom theme
import { myCustomTheme } from 'theme';
// redux actions

const appRoutes = {
  home: {
    path: '/',
    exact: true,
    label: 'Better Banking',
    showSearch: false,
    stickyFooter: false,
    component: SearchPage,
  },
  map: {
    path: '/map',
    exact: false,
    label: 'Better Banking Map',
    showSearch: false,
    stickyFooter: false,
    component: MapPage,
  },
  zipSearch: {
    path: '/search',
    exact: true,
    label: 'Find a Bank',
    showSearch: false,
    stickyFooter: true,
    component: SearchPage,
  },
  details: {
    path: '/detail/:bankRssd',
    exact: true,
    label: 'Bank Details',
    showSearch: true,
    stickyFooter: false,
    component: DetailPage,
  },
  admin: {
    path: '/admin',
    exact: true,
    label: 'Admin',
    stickyFooter: false,
    component: AdminComponent,
  },
  adminLogout: {
    path: '/admin/logout',
    exact: true,
    label: 'Log Out',
    stickyFooter: false,
    component: AdminLogoutComponent,
  },
  adminSignedIn: {
    path: '/admin/signed-in',
    exact: true,
    label: 'Signed In',
    stickyFooter: false,
    component: AdminSignedInComponent,
  },
  adminSignedOut: {
    path: '/admin/signed-out',
    exact: true,
    label: 'Signed Out',
    stickyFooter: false,
    component: AdminSignedOutComponent,
  },
  mdi: {
    path: '/bank-black',
    exact: true,
    label: 'Bank Black',
    stickyFooter: false,
    component: MdiPage,
  },
  tagList: {
    path: '/tagList',
    exact: false,
    label: 'Tag List',
    stickyFooter: true,
    component: TagListPage,
  },
};

const IndexApp = () => {
  useTitle('Better Banking');
  return (
    <Grommet theme={myCustomTheme} full>
      <Router>
        <Switch>
          {/* <Redirect exact from={'/'} to={'/home'} /> */}
          {Object.entries(appRoutes).map(
            ([
              routeName,
              {
                path,
                params = [],
                exact = false,
                component,
                label,
                showSearch,
                stickyFooter,
              },
            ]) => {
              return (
                <Route
                  key={routeName}
                  exact={exact}
                  path={path}
                  title={label}
                  component={withAppLayout({ showSearch, stickyFooter, label })(
                    component
                  )}
                />
              );
            }
          )}
          <Route
            component={withAppLayout({
              showSearch: false,
              stickyFooter: false,
              label: '404 Not Found',
            })(NotFoundPage)}
          />
        </Switch>
      </Router>
    </Grommet>
  );
};

export default IndexApp;
